export default __webpack_public_path__ + "static/bulletin-newsletter-22ffab67a86907fbb112f3427ae71eab.jpg";